<template>
  <v-container fluid>
    <!-- 타이틀 -->
    <page-header
      title="auth-to-user"
      :useList="buttonUseList"
      :usePermission="true"
      @btnSearch="retrieveGroupList"
    />
    <v-row>
      <v-col class="py-2">
        <!-- 조회 조건 -->
        <v-card class="px-4">
          <v-row>
            <v-col cols="12" md="6" lg="3">
              <!-- 시스템 -->
              <v-select :label="$t('system')" :items="systemList" item-text="app_nm" item-value="app_id" outlined dense hide-details v-model="groupGrid.retrieveData.app_id">
              </v-select>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="5">
        <!-- 그룹 -->
        <v-card>
          <v-card-title>
            <span class="font-weight-bold">{{ $t('group') }}</span>
          </v-card-title>
          <v-card-actions>
            <v-row no-gutters>
              <v-col cols="12" md class="py-1 px-1">
                <!-- 코드 -->
                <v-text-field :label="$t('code')" hide-details outlined dense v-model="groupGrid.retrieveData.authgrp_cd"
                              @keyup.enter="retrieveGroupList"></v-text-field>
              </v-col>
              <v-col cols="12" md class="py-1 px-1">
                <!-- 이름 -->
                <v-text-field :label="$t('name')" hide-details outlined dense v-model="groupGrid.retrieveData.authgrp_nm"
                              @keyup.enter="retrieveGroupList"></v-text-field>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text class="pt-0">
            <realgrid
              ref="groupRealGrid"
              class="mt-4 w-full"
              :options="groupGrid.gridOption"
              :fields="groupGrid.gridFields"
              :columns="groupGrid.gridColumns"
              :retrieveApi="retrieveGroupGrid"
              :retrieveData="groupGrid.retrieveData"
              :height="480"
            ></realgrid>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="7">
        <!-- 그룹 목록 -->
        <v-card>
          <v-card-title>
            <span class="font-weight-bold">{{ $t('group-list') }}</span>
          </v-card-title>
          <v-card-actions>
            <v-row no-gutters>
              <v-col cols="12" md="8" class="py-1 px-1">
                <v-radio-group v-model="addFlag" row hide-details class="mt-3 pa-0">
                  <v-radio :label="$t('user')" value="1"></v-radio>
                  <v-radio :label="$t('organization')" value="2"></v-radio>
                  <v-btn color="primary" small @click="openOrgPopup">{{ $t('list-add') }}</v-btn>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="4" class="px-1">
                <v-row no-gutters justify="end">
                  <v-col cols="6" md="auto" class="pa-1">
                    <v-btn color="primary" small :block="$vuetify.breakpoint.mdAndDown" v-permission="['btnCreate']" @click="save">{{ $t('label.save') }}</v-btn>
                  </v-col>
                  <v-col cols="6" md="auto" class="pa-1">
                    <v-btn color="primary" small :block="$vuetify.breakpoint.mdAndDown" v-permission="['btnDelete']" @click="del">{{ $t('label.delete') }}</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text class="pt-0">
            <div ref="userRealGrid" class="realgrid_style w-full mt-4"></div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- 사용자 dialog -->
    <v-dialog v-model="registOrg.usermodal" width="1200" v-if="registOrg.usermodal" scrollable>
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>사용자 등록</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="registOrg.usermodal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-4">
          <employee-tree ref="employeeTreeComp" :selected="addSelectedMember"></employee-tree>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="justify-end">
          <v-btn @click="userClosePopup" color="primary">추가</v-btn>
          <v-btn @click="registOrg.usermodal=false" color="primary">취소</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 조직 dialog -->
    <v-dialog v-model="registOrg.modal" width="1200" v-if="registOrg.modal" scrollable>
      <v-card>
        <v-card-title class="primary">
          <v-toolbar-title class="white--text">조직 등록</v-toolbar-title>
          <v-spacer/>
          <v-btn icon color="white" @click="registOrg.modal = false">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-tabs>
            <v-tab @click="selectTab('org')">
              인사
            </v-tab>
            <v-tab @click="selectTab('etcorg')">
              비인사
            </v-tab>
          </v-tabs>
          <v-card flat>
            <v-card-actions>
              <div style="width: 200px;">
                <v-select v-model="registOrg.retrieveData" :disabled="switchFlag" outlined dense hide-details
                          :items="companys" :item-value="item => item" item-text="asgn_shrt_nm"></v-select>
              </div>
            </v-card-actions>
            <v-card-text>
              <v-row>
                <v-col cols="10" md="4">
                  <div v-show="isSelectedTab('org')">
                    <realgrid-tree
                      ref="treeMenuGrid"
                      :options="registOrg.treeOption"
                      :fields="registOrg.treeFields"
                      :columns="registOrg.treeColumns"
                      :retrieveData="registOrg.retrieveData"
                      :retrieveApi="retreiveregistOrg"
                      :height="480"
                    ></realgrid-tree>
                  </div>
                  <div v-show="isSelectedTab('etcorg')">
                    <realgrid-tree
                      ref="etcOrgTree"
                      :options="etcOrgTreeConfig.treeOption"
                      :fields="etcOrgTreeConfig.treeFields"
                      :columns="etcOrgTreeConfig.treeColumns"
                      :retrieveApi="retrieveEtcOrg"
                      :height="480"
                    ></realgrid-tree>
                  </div>
                </v-col>
                <v-col cols="2" align-self="center" class="text-center">
                  <v-btn @click="addUserAuthMenu" small color="primary"><v-icon>mdi-chevron-double-right</v-icon></v-btn>
                </v-col>
                <v-col cols="12" md="6">
                  <div ref="addListRealGrid" class="realgrid_style"></div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="justify-end">
          <v-btn @click="orgClosePopup" color="primary">추가</v-btn>
          <v-btn @click="registOrg.modal=false" color="primary">취소</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import RealGridFactory from '@/utils/realgrid2'
import {
  getUserAuthData,
  getUserData,
  saveUserAuth,
  deleteUserAuth
} from '@/api/common/user' // user 데이터 API
import Message from '@/utils/message'
import { getSystems } from '@/api/manager/program' // 프로그램 데이터 API.
import { getOrg, getCompanys, getEtcOrg } from '@/api/manager/menu' // menu 데이터 API
import Realgrid from '@/components/grid/Realgrid' // 리얼그리드 컴포넌트 사용
import { getScrollOption } from '@/utils/scroll'
import { getAuthGroup } from '@/api/manager/auth' // auth 데이터 API
import RealgridTree from '@/components/grid/RealgridTree'
import EmployeeTree from '@/components/manager/EmployeeInDeptTree'
import envs from '@/envs'
import DispatchResize from '@/mixins/DispatchResize'
import PageHeader from '@/layout/components/PageHeader'

export default {
  name: 'AuthAddUser',
  components: {
    Realgrid,
    RealgridTree,
    EmployeeTree,
    PageHeader
  },
  mixins: [DispatchResize()],
  data() {
    return {
      buttonUseList: [
        'btnSearch'
      ],
      envsSys: envs.systemId,
      checkDblFlag: true,
      checkOFlag: true,
      checkFlag: true,
      switchFlag: false,
      addFlag: '1',
      systemList: [],
      companys: [],
      tabOps: {},
      ops: {
        vuescroll: {
          mode: 'native',
          sizeStrategy: 'percent',
          detectResize: true // DOM 크기 감지 여부
        },
        rail: {
          size: '10px', // 가로크기, default : 6px
          gutterOfEnds: '5px', // X축, Y축 양 끝에서의 거리, default : 2px
          gutterOfSide: '0' // 컨테이너 측면으로부터 거리, default : 2px
        },
        bar: {
          keepShow: true, // 계속 보여줄지 여부, default : false
          background: '#656a76', // @subColor_05
          opacity: 0.2,
          hoverStyle: false,
          size: '5px' // default : 6px
        },
        // 스크롤 좌우 버튼
        scrollButton: {
          enable: false // 사용 가능 여부
        },
        scrollPanel: {
          scrollingY: false // 스크롤 할 것인지 여부, default : true
        }
      },
      flags: {
        inited: false,
        default: false,
        verDefault: false,
        mapDefault: false
      },
      tabInfo: {
        selectedTab: 'org',
        active: [
          'bg-white',
          'block',
          'border-l',
          'border-t',
          'border-r',
          'rounded-t',
          'py-2',
          'px-4',
          'text-blue-dark',
          'font-semibold',
          'box_border_color',
          'text-blue-600'
        ],
        deactive: [
          'bg-white',
          'block',
          'py-2',
          'px-4',
          'text-blue',
          'hover:text-blue-darker',
          'font-semibold',
          'text-blue-600'
        ]
      },
      isLoading: false,
      group: {
        code: 'GRP0000001',
        name: ''
      },
      groupGrid: {
        retrieveData: {
          // 조회 파라미터
          authgrp_cd: '', // 권한 그룹 코드
          authgrp_nm: '', // 권한 그룹 명
          app_id: '', // 시스템 코드
          user_id: ''
        },
        // 그리드 옵션값
        gridOption: {
          gridView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            panel: {
              // 상단 패널 숨김
              visible: false
            },
            checkBar: {
              // 체크바 숨김
              visible: false
            },
            stateBar: {
              // 상태바 숨김
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            },
            footers: {
              // footer 보이지 않게 처리
              visible: false
            }
          },
          dataProvider: {
            softDeleting: true
          }
        },
        // 그리드 filed 배열
        gridFields: [],
        // 그리드 컬럼 배열
        gridColumns: []
      },
      userGrid: {
        gridObj: '',
        gridData: '',
        retrieveData: {
          // 조회 파라미터
          authgrp_cd: '',
          user_id: '', // 사용자 아이디
          user_nm: '', // 사용자명
          app_id: '' // 시스템 코드
        },
        // 그리드 옵션값
        gridOption: {
          gridView: {
            edit: {},
            panel: {
              // 상단 패널 숨김
              visible: false
            },
            checkBar: {
              // 체크바 숨김
              visible: true
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            },
            footers: {
              // footer 보이지 않게 처리
              visible: false
            },
            stateBar: {
              // 상태바 숨김
              visible: false
            }
          },
          dataProvider: {
            softDeleting: true
          }
        },
        // 그리드 filed 배열
        gridFields: [],
        // 그리드 컬럼 배열
        gridColumns: []
      },
      addUserGrid: {
        gridObj: '', // 그리드 인스턴스
        gridData: '',
        retrieveData: {
          // 조회 파라미터
          user_id: '', // 권한 그룹 코드
          user_nm: '', // 권한 그룹 명
          asgn_shrt_nm: '' // 시스템 코드
        },
        // 그리드 옵션값
        gridOption: {
          gridView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            panel: {
              // 상단 패널 숨김
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            },
            footers: {
              // footer 보이지 않게 처리
              visible: false
            },
            stateBar: {
              visible: false
            }
          },
          dataProvider: {
            softDeleting: true,
            deleteCreated: true
          }
        },
        // 그리드 filed 배열
        gridFields: [],
        // 그리드 컬럼 배열
        gridColumns: []
      },
      etcOrgTreeConfig: {
        columnVisible: true,
        treeOption: {
          tree: {
            idCol: 'asgn_cd', // 트리 구조를 만들 때 사용 할 아이디 컬럼
            prntIdCol: 'prnt_cd', // 트리 구조를 만들 때 사용 할 부모 아이디 컬럼
            levelCol: 'level', // 트리 구조를 만들 때 사용할 레벨 컬럼
            childCol: 'children', // 트리 구조를 만들 때 자식 노드들이 들어갈 컬럼
            sortCol: 'seq' // 트리 구조를 만들 때 정렬을 위한 컬럼
          },
          // treeView 영역에 셋팅할 옵션들
          treeView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정 하지 않음
              fitStyle: 'even'
            },
            stateBar: {
              visible: false
            },
            footers: {
              visible: false
            }
          },
          treeDataProvider: {
            softDeleting: true,
            deleteCreated: true
          }
        },
        treeFields: [],
        treeColumns: []
      },
      orgList: [],
      registOrg: {
        // 메뉴 트리 그리드
        modal: false,
        usermodal: false,
        gridObj: '', // 그리드 인스턴스
        gridData: '', // 그리드 데이터
        retrieveData: {
          company: '',
          asgn_cd: ''
        },
        treeOption: {
          tree: {
            idCol: 'asgn_cd', // 트리 구조를 만들 때 사용 할 아이디 컬럼
            prntIdCol: 'prnt_cd', // 트리 구조를 만들 때 사용 할 부모 아이디 컬럼
            levelCol: 'level', // 트리 구조를 만들 때 사용할 레벨 컬럼
            childCol: 'children', // 트리 구조를 만들 때 자식 노드들이 들어갈 컬럼
            sortCol: 'seq' // 트리 구조를 만들 때 정렬을 위한 컬럼
          },
          // treeView 영역에 셋팅할 옵션들
          treeView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정 하지 않음
              fitStyle: 'even'
            },
            stateBar: {
              visible: false
            },
            footers: {
              visible: false
            }
          },
          // dataProvider 영역에 셋팅할 옵션들
          treeDataProvider: {
            softDeleting: true,
            deleteCreated: true
          }
        }
      },
      addListGrid: {
        gridObj: '', // 그리드 인스턴스
        gridData: '',
        retrieveData: {
          // 조회 파라미터
          authgrp_cd: '', // 권한 그룹 코드
          authgrp_nm: '', // 권한 그룹 명
          app_id: '' // 시스템 코드
        },
        // 그리드 옵션값
        gridOption: {
          gridView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            panel: {
              // 상단 패널 숨김
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            },
            stateBar: {
              visible: false
            },
            footers: {
              visible: false
            }
          },
          dataProvider: {
            softDeleting: true,
            deleteCreated: true
          }
        },
        // 그리드 filed 배열
        gridFields: [],
        // 그리드 컬럼 배열
        gridColumns: []
      },
      flag: {
        uploadPopup: false,
        manualPopup: false,
        uploadByCsv: false,
        uploadType: ''
      },
      popup: {
        popupWidths: {
          widthXl: 'w-2/3'
        },
        contentMiniPopuHeights: {
          // 팝업 높이값
          heightLg: 'con_popup_h_65',
          heightXl: 'con_popup_h_65'
        }
      }
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
    Promise.all([getCompanys()]).then(responses => {
      this.companys = responses[0]
      this.registOrg.retrieveData = this.companys[0]
    })
    this.groupGrid.gridFields = [
      { fieldName: 'authgrp_cd', dataType: 'string' },
      { fieldName: 'authgrp_nm', dataType: 'string' },
      { fieldName: 'use_yn', dataType: 'string' },
      { fieldName: 'admingrp_yn', dataType: 'string' },
      { fieldName: 'insert_user_id', dataType: 'string' }
    ]
    // 그룹 그리드 컬럼
    this.groupGrid.gridColumns = [
      {
        name: 'authgrp_cd',
        fieldName: 'authgrp_cd',
        header: {
          text: '아이디'
        },
        width: 100,
        styles: {
          textAlignment: 'center'
        },
        visible: true,
        editable: false
      },
      {
        name: 'authgrp_nm',
        fieldName: 'authgrp_nm',
        header: {
          text: '이름'
        },
        width: 150,
        visible: true,
        editable: false
      },
      {
        name: 'use_yn',
        fieldName: 'use_yn',
        header: {
          text: '사용여부'
        },
        width: 60,
        visible: true,
        renderer: {
          type: 'check',
          shape: 'box',
          falseValues: 'false'
        },
        styles: {
          textAlignment: 'center'
        },
        editable: false
      },
      {
        name: 'admingrp_yn',
        fieldName: 'admingrp_yn',
        header: {
          text: '관리자 그룹 여부'
        },
        width: 60,
        visible: true,
        renderer: {
          type: 'check',
          shape: 'box',
          falseValues: 'N',
          trueValues: 'Y'
        },
        styles: {
          textAlignment: 'center'
        },
        editable: false
      }
    ]
    this.registOrg.treeFields = [
      // menuTree 구조를 위한 필수 field들
      { fieldName: 'tree', dataType: 'string' },
      { fieldName: 'children', dataType: 'string' }, // treeOption.tree.childCol 과 동일해야한다
      // 조회 후 넘어오는 data 필드들
      { fieldName: 'asgn_shrt_nm', dataType: 'string' },
      { fieldName: 'asgn_cd', dataType: 'string' }, // teeOption.tree.idCol 과 동일
      { fieldName: 'prnt_cd', dataType: 'string' }, // teeOption.tree.prntCol 과 동일
      { fieldName: 'level', dataType: 'number' }, // teeOption.tree.levelCol 과 동일
      { fieldName: 'clss_cd', dataType: 'string' }, // teeOption.tree.sortCol 과 동일
      { fieldName: 'asgn_full_nm', dataType: 'string' }, // teeOption.tree.sortCol 과 동일
      { fieldName: 'company', dataType: 'string' }, // teeOption.tree.sortCol 과 동일
      { fieldName: 'checkAble', dataType: 'string' } // 체크 가능 여부
    ]

    // 트리 컬럼에는 사용자에게 보여질 컬럼만 선언되면 된다.
    this.registOrg.treeColumns = [
      {
        name: 'asgn_shrt_nm',
        fieldName: 'asgn_shrt_nm',
        header: {
          text: '이름'
        },
        width: 220,
        editable: false
      }
    ]
    this.groupGrid.retrieveData.app_id = this.envsSys

    this.etcOrgTreeConfig.treeFields = [
      { fieldName: 'asgn_cd', dataType: 'string' },
      { fieldName: 'asgn_shrt_nm', dataType: 'string' },
      { fieldName: 'asgn_full_nm', dataType: 'string' },
      { fieldName: 'company', dataType: 'string' },
      { fieldName: 'bsns_cd', dataType: 'string' },
      { fieldName: 'prnt_cd', dataType: 'string' },
      { fieldName: 'insert_user_id', dataType: 'string' },
      { fieldName: 'insert_date', dataType: 'string' },
      { fieldName: 'update_user_id', dataType: 'string' },
      { fieldName: 'update_date', dataType: 'string' }
    ]
    // 그룹 그리드 컬럼
    this.etcOrgTreeConfig.treeColumns = [
      {
        name: 'asgn_cd',
        fieldName: 'asgn_cd',
        header: {
          text: '소속코드'
        },
        width: 110,
        visible: true,
        editable: false
      },
      {
        name: 'asgn_shrt_nm',
        fieldName: 'asgn_shrt_nm',
        header: {
          text: '소속 조직명'
        },
        width: 150,
        visible: true,
        editable: false
      }
    ]
  },
  async mounted() {
    await getSystems().then(res => {
      this.systemList = res
    })
    await this.retrieveGroupList()
    await this.setUserGrid()
    // await this.setAddGrid()
    // 권한그룹 코드 선택 전에는 권한 그룹별 메뉴 리스트가 비어있는 상태
    // this.addListGrid.gridObj.fillByJson([])
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    getBlankTitle() {
      return this.count > 10 ? '10 초과입니다.' : '10 이하입니다.'
    },
    retrieveGroupGrid() {
      // 그룹 그리드 데이터 조회
      return getAuthGroup
    },
    retreiveregistOrg() {
      return getOrg
    },
    retrieveEtcOrg() {
      return getEtcOrg
    }
  },
  methods: {
    appMap() {
      this.userGrid.retrieveData.app_id = this.groupGrid.retrieveData.app_id
      this.retrieveGroupList()
    },
    retrieveUserGrid() {
      getUserAuthData(this.userGrid.retrieveData).then(responses => {
        // 조회한 데이터를 넣어준다.
        this.userGrid.gridData = responses
        // 기본 컬럼, 필드 셋팅
        this.userGrid.gridObj.initGrid(
          this.userGrid.gridFields,
          this.userGrid.gridColumns
        )
        // 그리드에 데이터를 넣어준다.
        this.userGrid.gridObj.fillByJson(this.userGrid.gridData)
        // 확장 권한 컬럼의 가장 큰 값을 기준으로 필드와 컬럼을 생성해준다
      })
    },
    async setUserGrid() {
      // 그룹 그리드 컬럼
      this.userGrid.gridFields = [
        { fieldName: 'authgrp_asg_cls', dataType: 'string' },
        { fieldName: 'user_id', dataType: 'string' },
        { fieldName: 'user_nm', dataType: 'string' },
        { fieldName: 'company', dataType: 'string' },
        { fieldName: 'asgn_full_nm', dataType: 'string' },
        { fieldName: 'user_type', dataType: 'string' },
        { fieldName: 'access_ip_list', dataType: 'string' }
      ]
      this.userGrid.gridColumns = [
        {
          name: 'authgrp_asg_cls',
          fieldName: 'authgrp_asg_cls',
          header: {
            text: '구분'
          },
          width: 50,
          styles: {
            textAlignment: 'center'
          },
          visible: true,
          editable: false
        },
        {
          name: 'user_id',
          fieldName: 'user_id',
          header: {
            text: '아이디'
          },
          width: 60,
          visible: true,
          editable: false,
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'user_nm',
          fieldName: 'user_nm',
          header: {
            text: '성명'
          },
          visible: true,
          editable: false,
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'company',
          fieldName: 'company',
          header: {
            text: '회사코드'
          },
          width: 50,
          visible: true,
          editable: false,
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'asgn_full_nm',
          fieldName: 'asgn_full_nm',
          header: {
            text: '소속'
          },
          width: 100,
          visible: true,
          editable: false,
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'access_ip_list',
          fieldName: 'access_ip_list',
          header: {
            text: '접근 클라이언트 IP'
          },
          width: 100,
          visible: true,
          editable: true,
          styles: {
            textAlignment: 'center'
          }
        }
      ]
      this.userGrid.gridObj = await RealGridFactory(
        this.$refs.userRealGrid,
        this.userGrid.gridOption
      )
      // dynamic 스타일 지정 및 그리드 컬럼,필드 셋팅
      this.userGrid.gridObj.autoSetDynamicStyle(this.userGrid.gridColumns)
      this.userGrid.gridObj.initGrid(
        this.userGrid.gridFields,
        this.userGrid.gridColumns
      )
      this.userGrid.gridObj.fillByJson([]) // 빈 값 넣어줌 (권한그룹코드가 없는 상태)
      this.$refs.groupRealGrid.getGridView().onCurrentRowChanged = (
        cgrid,
        oldRowIdx,
        newRowIdx
      ) => {
        if (newRowIdx === -1) {
        } else {
          this.userGrid.gridObj.gInvoke('commit') // 그룹별 메뉴 수정중이던 사항 commit
          var newRowData = this.$refs.groupRealGrid
            .getDataProvider()
            .getJsonRow(newRowIdx) // 선택된 row 데이터를 가져온다
          this.userGrid.retrieveData.app_id = this.groupGrid.retrieveData.app_id
          this.userGrid.retrieveData.authgrp_cd = newRowData.authgrp_cd // 선택된 row의 권한그룹 코드를 가져와 그룹별 메뉴 그리드의 검색조건으로 넣는다.
          this.retrieveUserGrid() // 그룹별 메뉴 그리드 조회
        }
      }
      // this.$nextTick(() => {
      //   // 내부 그리드의 width가 시점 문제로 조정 되지 않는 이슈는 글로벌 이벤트로 해결
      //   this.dispatchResize()
      // })
    },
    async setetcOrgTreeConfig() {
      this.$refs.etcOrgTree.retrieve()
      this.$nextTick(() => {
        this.$refs.etcOrgTree.getTreeView().onDataCellDblClicked = (
          cgrid,
          index
        ) => {
          // var a = this.registOrg.treeView.getCurrent()
          // var b = this.registOrg.treeDataProvider.getJsonRow(a.dataRow)
          var AllData = this.addListGrid.gridObj.d().getJsonRows(-1)
          var dataRow = this.$refs.etcOrgTree.getTreeView().getCurrent() // dataRow 값 가져옴
          var rowData = this.$refs.etcOrgTree
            .getTreeDataProvider()
            .getJsonRow(dataRow.dataRow) // row의 데이터 가져옴
          for (var key in AllData) {
            // 입력된 데이터와 같으면 return false
            if (rowData.asgn_cd === AllData[key].asgn_cd) {
              Message.err(
                '부서 아이디 : [' +
                rowData.asgn_cd +
                ']는 이미 존재하는 목록입니다.'
              )
              this.checkDblFlag = false
            } else {
            }
          }
          if (this.checkDblFlag === true) {
            this.addListGrid.gridObj
              .d()
              .insertRow(0, [
                rowData.company,
                rowData.asgn_cd,
                rowData.asgn_shrt_nm,
                rowData.asgn_full_nm
              ]) // 기본값 셋팅
          } else {
          }
          this.checkDblFlag = true
          this.addListGrid.gridObj.getGridView().checkAll(true)
        }
      })
    },
    changedOrg() {
      this.$nextTick(() => {
        this.$refs.treeMenuGrid.retrieve()
      })
    },
    async setAddGrid() {
      this.addListGrid.gridFields = [
        { fieldName: 'company', dataType: 'string' },
        { fieldName: 'asgn_cd', dataType: 'string' },
        { fieldName: 'asgn_shrt_nm', dataType: 'string' },
        { fieldName: 'asgn_full_nm', dataType: 'string' }
      ]
      // 그룹 그리드 컬럼
      this.addListGrid.gridColumns = [
        {
          name: 'company',
          fieldName: 'company',
          header: {
            text: '구분'
          },
          width: 80,
          styles: {
            textAlignment: 'center'
          },
          visible: true,
          editable: false
        },
        {
          name: 'asgn_cd',
          fieldName: 'asgn_cd',
          header: {
            text: '조직 코드'
          },
          width: 80,
          visible: true,
          editable: false
        },
        {
          name: 'asgn_shrt_nm',
          fieldName: 'asgn_shrt_nm',
          header: {
            text: '조직 이름'
          },
          width: 100,
          visible: true,
          editable: false
        },
        {
          name: 'asgn_full_nm',
          fieldName: 'asgn_full_nm',
          header: {
            text: '전체 이름'
          },
          width: 80,
          visible: true,
          editable: false
        }
      ]
      this.addListGrid.gridObj = await RealGridFactory(
        this.$refs.addListRealGrid,
        this.addListGrid.gridOption
      )
      // dynamic 스타일 지정 및 그리드 컬럼,필드 셋팅
      this.addListGrid.gridObj.autoSetDynamicStyle(this.addListGrid.gridColumns)
      this.addListGrid.gridObj.initGrid(
        this.addListGrid.gridFields,
        this.addListGrid.gridColumns
      )
    },
    setTreeGrid() {
      this.$refs.treeMenuGrid.retrieve()
      this.$nextTick(() => {
        this.$refs.treeMenuGrid.getTreeView().onDataCellDblClicked = (
          cgrid,
          index
        ) => {
          // var a = this.registOrg.treeView.getCurrent()
          // var b = this.registOrg.treeDataProvider.getJsonRow(a.dataRow)
          var AllData = this.addListGrid.gridObj.d().getJsonRows(-1)
          var dataRow = this.$refs.treeMenuGrid.getTreeView().getCurrent() // dataRow 값 가져옴
          var rowData = this.$refs.treeMenuGrid
            .getTreeDataProvider()
            .getJsonRow(dataRow.dataRow) // row의 데이터 가져옴
          for (var key in AllData) {
            // 입력된 데이터와 같으면 return false
            if (rowData.asgn_cd === AllData[key].asgn_cd) {
              Message.err(
                '부서 아이디 : [' +
                rowData.asgn_cd +
                ']는 이미 존재하는 목록입니다.'
              )
              this.checkDblFlag = false
            } else {
            }
          }
          if (this.checkDblFlag === true) {
            this.addListGrid.gridObj
              .d()
              .insertRow(0, [
                rowData.company,
                rowData.asgn_cd,
                rowData.asgn_shrt_nm,
                rowData.asgn_full_nm
              ]) // 기본값 셋팅
          } else {
          }
          this.checkDblFlag = true
          this.addListGrid.gridObj.getGridView().checkAll(true)
        }
      })
    },
    async setAddUserGrid() {
      this.addUserGrid.gridFields = [
        { fieldName: 'gubun', dataType: 'string' },
        { fieldName: 'user_id', dataType: 'string' },
        { fieldName: 'user_nm', dataType: 'string' },
        { fieldName: 'asgn_shrt_nm', dataType: 'string' },
        { fieldName: 'asgn_full_nm', dataType: 'string' },
        { fieldName: 'company', dataType: 'string' },
        { fieldName: 'checkAble', dataType: 'string' }
      ]
      // 그룹 그리드 컬럼
      this.addUserGrid.gridColumns = [
        {
          name: 'gubun',
          fieldName: 'gubun',
          header: {
            text: '구분'
          },
          width: 50,
          styles: {
            textAlignment: 'center'
          },
          visible: true,
          editable: false
        },
        {
          name: 'user_id',
          fieldName: 'user_id',
          header: {
            text: '아이디'
          },
          width: 60,
          visible: true,
          editable: false,
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'user_nm',
          fieldName: 'user_nm',
          header: {
            text: '성명'
          },
          width: 100,
          visible: true,
          editable: false,
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'company',
          fieldName: 'company',
          header: {
            text: '회사코드'
          },
          width: 50,
          visible: true,
          editable: false,
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'asgn_shrt_nm',
          fieldName: 'asgn_shrt_nm',
          header: {
            text: '부서'
          },
          width: 100,
          visible: true,
          editable: false,
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'asgn_full_nm',
          fieldName: 'asgn_full_nm',
          header: {
            text: '소속'
          },
          width: 80,
          visible: true,
          editable: false,
          styles: {
            textAlignment: 'center'
          }
        }
      ]
      this.addUserGrid.gridObj = await RealGridFactory(
        this.$refs.addUserRealGrid,
        this.addUserGrid.gridOption
      )
      // dynamic 스타일 지정 및 그리드 컬럼,필드 셋팅
      this.addUserGrid.gridObj.autoSetDynamicStyle(this.addUserGrid.gridColumns)
      this.addUserGrid.gridObj.initGrid(
        this.addUserGrid.gridFields,
        this.addUserGrid.gridColumns
      )
    },
    checkMenuTree() {
      this.$refs.treeMenuGrid.getTreeView().setAllCheck(false) // 상단 전체 체크 영역 해제
      this.$refs.treeMenuGrid.getTreeView().checkAll(false, true) // 전체 체크 해제(접혀있는 행 포함)
      var allTreeDataRows = this.$refs.treeMenuGrid
        .getTreeDataProvider()
        .getDescendants(-1) // 전체 dataRow 가져옴
      var userMenuGridAllData = this.addListGrid.gridObj.d().getJsonRows(-1)
      allTreeDataRows.forEach(dataRow => {
        var rowData = this.$refs.treeMenuGrid
          .getTreeDataProvider()
          .getJsonRow(dataRow) // 해당 row 의 데이터 가져옴
        var findObj = _.find(userMenuGridAllData, { menu_id: rowData.menu_id }) // 조회된 권한별 메뉴 데이터에 해당 메뉴가 속할경우
        if (findObj) {
          this.$refs.treeMenuGrid
            .getTreeDataProvider()
            .setValue(dataRow, 'checkAble', 'N') // 체크 가능여부 N 처리
        } else {
          // 속하지 않을경우
          this.$refs.treeMenuGrid
            .getTreeDataProvider()
            .setValue(dataRow, 'checkAble', 'Y') // 체크 가능여부 Y 처리
        }
      })
    },
    addUserAuthMenu() {
      // 전체 트리 그리드 펼침 (펼치치 않으면 펼쳐지지 않은 데이터에 대해서 check 된 row로 인지 못함)
      // this.$refs.treeMenuGrid.getTreeView().expandAll()
      if (this.tabInfo.selectedTab === 'etcorg') {
        var checkItems = this.$refs.etcOrgTree
          .getTreeView()
          .getCheckedItems() // check된 row itemIndex 가져옴
        var AllData = this.addListGrid.gridObj.d().getJsonRows(-1)
        for (let i = checkItems.length - 1; i >= 0; i--) {
        //   // 체크된 순서대로 넣기 위해 거꾸로 넣어줌
          var dataRow = this.$refs.etcOrgTree
            .getTreeView()
            .getDataRow(checkItems[i]) // dataRow 값 가져옴
          var rowData = this.$refs.etcOrgTree
            .getTreeDataProvider()
            .getJsonRow(dataRow) // row의 데이터 가져옴
          for (var key in AllData) {
            // 입력된 데이터와 같으면 return false
            if (rowData.asgn_cd === AllData[key].asgn_cd) {
              Message.err(
                '부서 아이디 : [' +
                  rowData.asgn_cd +
                  ']는 이미 존재하는 목록입니다.'
              )
              this.checkDblFlag = false
            } else {
            }
          }
          if (this.checkDblFlag === true) {
            this.addListGrid.gridObj
              .d()
              .insertRow(0, [
                rowData.company,
                rowData.asgn_cd,
                rowData.asgn_shrt_nm,
                rowData.asgn_full_nm
              ]) // 기본값 셋팅
          }
          this.$refs.treeMenuGrid.getTreeView().checkItem(checkItems[i], false) // 추가한 row는 체크 해제
          // this.addListGrid.gridObj.getGridView().checkItem(true) // 추가한 row는 체크 해제
          this.$refs.treeMenuGrid
            .getTreeDataProvider()
            .setValue(dataRow, 'checkAble', 'N') // 체크 가능여부 N 처리
        }
        // this.$refs.treeMenuGrid.getTreeView().collapseAll(true) // 전체 트리 접어줌
        this.addListGrid.gridObj.getGridView().checkAll(true)
        this.checkDblFlag = true
      } else {
        var checkItems2 = this.$refs.treeMenuGrid
          .getTreeView()
          .getCheckedItems() // check된 row itemIndex 가져옴
        var AllData2 = this.addListGrid.gridObj.d().getJsonRows(-1)
        for (let i = checkItems2.length - 1; i >= 0; i--) {
          // 체크된 순서대로 넣기 위해 거꾸로 넣어줌
          var dataRow2 = this.$refs.treeMenuGrid
            .getTreeView()
            .getDataRow(checkItems2[i]) // dataRow 값 가져옴
          var rowData2 = this.$refs.treeMenuGrid
            .getTreeDataProvider()
            .getJsonRow(dataRow2) // row의 데이터 가져옴
          for (var key2 in AllData2) {
            // 입력된 데이터와 같으면 return false
            if (rowData2.asgn_cd === AllData2[key2].asgn_cd) {
              Message.err(
                '부서 아이디 : [' +
                  rowData2.asgn_cd +
                  ']는 이미 존재하는 목록입니다.'
              )
              this.checkDblFlag = false
            } else {
            }
          }
          if (this.checkDblFlag === true) {
            this.addListGrid.gridObj
              .d()
              .insertRow(0, [
                rowData2.company,
                rowData2.asgn_cd,
                rowData2.asgn_shrt_nm,
                rowData2.asgn_full_nm
              ]) // 기본값 셋팅
          } else {
          }
          this.$refs.treeMenuGrid.getTreeView().checkItem(checkItems2[i], false) // 추가한 row는 체크 해제
          // this.addListGrid.gridObj.getGridView().checkItem(true) // 추가한 row는 체크 해제
          this.$refs.treeMenuGrid
            .getTreeDataProvider()
            .setValue(dataRow, 'checkAble', 'N') // 체크 가능여부 N 처리
        }
        // this.$refs.treeMenuGrid.getTreeView().collapseAll(true) // 전체 트리 접어줌
        this.addListGrid.gridObj.getGridView().checkAll(true)
        this.checkDblFlag = true
      }
    },
    addOut() {
      var AllData = this.userGrid.gridObj.d().getJsonRows(-1)
      // 전체 트리 그리드 펼침 (펼치치 않으면 펼쳐지지 않은 데이터에 대해서 check 된 row로 인지 못함)
      var checkItems = this.addListGrid.gridObj.getGridView().getCheckedItems() // check된 row itemIndex 가져옴
      for (var i = 0; i < checkItems.length; i++) {
        var dataRow2 = this.addListGrid.gridObj
          .getGridView()
          .getDataRow(checkItems[i]) // dataRow 값 가져옴
        var rowData2 = this.addListGrid.gridObj
          .getDataProvider()
          .getJsonRow(dataRow2)
        for (var key in AllData) {
          // 입력된 데이터와 같으면 return false
          if (AllData[key].user_id === rowData2.asgn_cd) {
            Message.err(
              '부서 아이디 : [' +
                rowData2.asgn_cd +
                ']는 이미 존재하는 목록입니다.'
            )
            this.checkOFlag = false
          } else {
          }
        }
      }
      if (this.checkOFlag === true) {
        for (let i = checkItems.length - 1; i >= 0; i--) {
          // 체크된 순서대로 넣기 위해 거꾸로 넣어줌
          var dataRow = this.addListGrid.gridObj
            .getGridView()
            .getDataRow(checkItems[i]) // dataRow 값 가져옴
          var rowData = this.addListGrid.gridObj
            .getDataProvider()
            .getJsonRow(dataRow) // row의 데이터 가져옴
          this.userGrid.gridObj
            .d()
            .insertRow(0, [
              'D',
              rowData.asgn_cd,
              rowData.asgn_shrt_nm,
              rowData.company,
              rowData.asgn_full_nm
            ]) // 기본값 셋팅
        }
        this.registOrg.modal = false
      }
      this.checkOFlag = true
    },
    addUserOut() {
      var AllData = this.userGrid.gridObj.d().getJsonRows(-1)
      // 전체 트리 그리드 펼침 (펼치치 않으면 펼쳐지지 않은 데이터에 대해서 check 된 row로 인지 못함)
      var checkItems = this.addUserGrid.gridObj.getGridView().getCheckedItems() // check된 row itemIndex 가져옴
      for (var i = 0; i < checkItems.length; i++) {
        var dataRow2 = this.addUserGrid.gridObj
          .getGridView()
          .getDataRow(checkItems[i]) // dataRow 값 가져옴
        var rowData2 = this.addUserGrid.gridObj
          .getDataProvider()
          .getJsonRow(dataRow2)
        for (var key in AllData) {
          // 입력된 데이터와 같으면 return false
          if (AllData[key].user_id === rowData2.user_id) {
            Message.err(
              '유저아이디 : [' +
                rowData2.user_id +
                ']는 이미 존재하는 목록입니다.'
            )
            this.checkFlag = false
          } else {
          }
        }
      }
      if (this.checkFlag === true) {
        for (let i = checkItems.length - 1; i >= 0; i--) {
          // 체크된 순서대로 넣기 위해 거꾸로 넣어줌
          var dataRow = this.addUserGrid.gridObj
            .getGridView()
            .getDataRow(checkItems[i]) // dataRow 값 가져옴
          var rowData = this.addUserGrid.gridObj
            .getDataProvider()
            .getJsonRow(dataRow) // row의 데이터 가져옴
          this.userGrid.gridObj
            .d()
            .insertRow(0, [
              'P',
              rowData.user_id,
              rowData.user_nm,
              rowData.company,
              rowData.asgn_shrt_nm,
              rowData.asgn_full_nm
            ]) // 기본값 셋팅
        }
        this.registOrg.usermodal = false
      }
      this.checkFlag = true
    },
    save() {
      let grid = this.userGrid.gridObj
      try {
        grid.g().commit()
      } catch (e) {
        Message.err(e.message)
        return
      }

      if (confirm('저장하시겠습니까?')) {
        // 저장을 위한 데이터를 가져온다.
        let saveDataSet = grid.getDataForSave()
        // 파라미터를 정의한다.
        saveDataSet.parameter = {
          authgrp_cd: this.userGrid.retrieveData.authgrp_cd,
          deleteAndInsert: false, // CSV 업로드 시 사용되며 이 값이 true로 셋팅되면 서버에서는 기존 데이터를 모두 지우고, 새로운 데이터 값 중 created 부분을 입력한다.
          system_id: this.groupGrid.retrieveData.app_id
        }
        if (this.flag.uploadByCsv) {
          saveDataSet.parameter.deleteAndInsert = true
        }

        // 저장을 위한 로직 출력
        saveUserAuth(saveDataSet).then(res => {
          if (!res.result) {
            res.result = { resMsg: '' }
          }
          Message.success(
            '그룹목록 저장이 완료 되었습니다.' + res.result.resMsg
          )
          this.retrieveUserGrid()
          // csv 플레그 초기화
          if (this.flag.uploadByCsv) {
            this.flag.uploadByCsv = false
            this.retrieveProgramList()
          } else {
            let grid = this.programGrid.gridObj
            // Grid의 전체 데이터를 가져옴
            let gridData = grid.d().getJsonRows(0, -1)

            // 에러 결과를 저장 한다. 동적 행 색상 입힐 때 사용
            res.created.forEach(row => {
              grid.setCreatedRowStatus(gridData, row)
            })
            res.updated.forEach(row => {
              grid.setUpdatedRowStatus(gridData, row)
            })
            grid.fillByJson(gridData)
            // 에러 결과인 요건에 대해 다시 Realgrid Row Status를 변경
            res.created.forEach(row => {
              grid.restoreGridCreatedDataStatus(row)
            })
            res.updated.forEach(row => {
              grid.restoreGridUpdatedDataStatus(row)
            })
          }
        })
      }
    },
    del() {
      // 체크 박스로 선택한 rows 번호를 가져온다.
      let gridView = this.userGrid.gridObj.g()
      let dataProvider = this.userGrid.gridObj.d()
      gridView.commit()

      let rows = gridView.getCheckedRows(true)
      if (rows.length < 1) {
        Message.warn('삭제할 대상이 없습니다.')
        return
      }
      var authGroupCD = {
        authgrp_cd: this.userGrid.retrieveData.authgrp_cd
      }
      var deleteDataSet = {
        deleted: []
      }
      rows.forEach((row, idx) => {
        let target = dataProvider.getJsonRow(row)
        if (!target.user_id) {
          return
        }
        deleteDataSet.deleted.push(target)
      })
      if (confirm('선택한 목록을 삭제하시겠습니까?')) {
        deleteUserAuth(deleteDataSet, authGroupCD).then(res => {
          let prefix = '목록 삭제가 완료 되었습니다.'
          Message.success(prefix + res.result.resMsg)
          this.retrieveUserGrid()
        })
      }
    },
    retrieveUserData() {
      // 유저 데이터를 그리드에 넣는다.
      if (this.addUserGrid.retrieveData.user_nm.length === 1) {
        Message.warn('이름을 두글자 이상 입력 해 주세요')
      } else if (
        !this.addUserGrid.retrieveData.asgn_shrt_nm &&
        !this.addUserGrid.retrieveData.user_nm &&
        !this.addUserGrid.retrieveData.user_id
      ) {
        Message.err('검색조건은 반드시 1개 이상이여야 합니다.')
      } else {
        getUserData(this.addUserGrid.retrieveData).then(res => {
          this.addUserGrid.gridObj.fillByJson(res)
        })
      }
    },
    retrieveGroupList() {
      // 권한그룹 데이터를 그리드에 넣는다.
      this.$refs.groupRealGrid.retrieve().then(() => {
        this.$refs.groupRealGrid.getGridView().setFocus()
      })
    },
    retrieveMenuTree(flag) {
      this.$refs.treeMenuGrid.retrieve().then(() => {
        this.checkMenuTree() // 메뉴 트리에서 그룹별 메뉴 리스트에 있는 항목들 checkAble 처리
      })
      // flag 가 true 이면 check 가능여부에 대한 조건을 넣는다. (최초 조회시 1번만 실행됨)
      if (flag) {
        this.$refs.treeMenuGrid
          .getTreeView()
          .setCheckableExpression("values['checkAble'] = 'Y'", true)
      }
    },
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    scrollOps() {
      let ops = {
        scrollPanel: {
          scrollingY: false,
          scrollingX: true
        }
      }
      this.tabOps = getScrollOption(ops)
    },
    // 현재 선택된 tab이면 v-show가 true 가 되어 해당 탭이 보여진다.
    isSelectedTab(tabName) {
      return this.tabInfo.selectedTab === tabName
    },
    // tab li 태그의 class 를 가져온다
    getTabNameLiClass(tabName) {
      return this.isSelectedTab(tabName) ? '-mb-px' : ''
    },
    // tab a 태그의 class 를 가져온다
    getTabNameAClass(tabName) {
      return this.tabInfo.selectedTab === tabName
        ? this.tabInfo.active
        : this.tabInfo.deactive
    },
    // 탭 클릭 이벤트
    selectTab(tabName) {
      if (this.flags.default) return // FIXME : 마지막에 풀어라
      // 선택된 값을 변수에 담는다
      this.tabInfo.selectedTab = tabName
      if (this.tabInfo.selectedTab === 'etcorg') {
        this.switchFlag = true
      } else {
        this.switchFlag = false
      }
      this.$nextTick(() => {
        // 내부 그리드의 width가 시점 문제로 조정 되지 않는 이슈는 글로벌 이벤트로 해결
        this.dispatchResize()
      })
    },
    openOrgPopup() {
      // this.isLoading = true
      if (this.addFlag === '1') {
        this.registOrg.usermodal = true
        this.$nextTick(() => {
          // this.setAddUserGrid()
        })
      } else if (this.addFlag === '2') {
        this.tabInfo.selectedTab = 'org'
        this.switchFlag = false
        this.registOrg.modal = true
        this.$nextTick(() => {
          this.setAddGrid()
          this.setetcOrgTreeConfig()
          this.setTreeGrid()
        })
      }
    },
    userClosePopup() {
      this.$refs.employeeTreeComp.getSelectedItem()
      this.registOrg.usermodal = false
    },
    orgClosePopup(result) {
      this.addOut()
    },
    addSelectedMember(results) {
      let isDup = false
      let dataProvider = this.userGrid.gridObj.d()
      let AllData = dataProvider.getJsonRows(-1)
      results.forEach((rowData, idx) => {
        isDup = false
        for (var dataRow of AllData) {
          if (dataRow.user_id === rowData.user_id) {
            isDup = true
          }
        }
        if (!isDup) {
          dataProvider.insertRow(0, [
            'P',
            rowData.user_id,
            rowData.user_nm,
            rowData.company,
            rowData.asgn_shrt_nm,
            rowData.asgn_full_nm
          ])
        }
      })
    }
  },
  beforeDestroy() {}
}
</script>

<style scoped>
.realgrid_style {
  height: 480px;
}
</style>
